<ng-template #branch let-treeNodes>
  <div *ngFor="let item of treeNodes;let index= index">
    <ng-container *ngTemplateOutlet="leaf; context: {item: item,siblings: treeNodes, index: index+1}">
    </ng-container>
  </div>
</ng-template>

<!-- leaf node -->
<ng-template let-item="item" let-siblings="siblings" let-index="index" #leaf>
  <div class="table-view create-project-tree px-4" *ngIf="isFilterApplied ? item.isSearchResult : true">
    <div [class.shifted]="item.reorder === 1">
      <div id="headingOne_{{item.id}}" [ngClass]="[item.children?.length===0?'last-child-node':'']">

        <div class="row mx-0 tr justify-content-between" *ngIf="item"
          [ngClass]="[viewLocation === 'create-project'?'create-project-tree-space':'']">

          <div class="w-100 d-flex align-items-top" [style.padding-left]="calculatePadding(item.level)">
            <button
              type="button"
              *ngIf="item.children && item.children.length > 0"
              class="btn btn-clear toggle-caret mr-2 p-0 font-4x"
              id="{{ item.id }}-atag"
              (click)="item.expand = !item.expand"
              aria-label="Tree view taxonomy"
              [attr.aria-expanded]="item.expand"
              >
              <span 
                class="material-icons-outlined font-5x"
                aria-hidden="true">
                {{item.expand ?'arrow_drop_down':'arrow_right' }}
              </span>
            </button>
            <span
              [ngStyle]="{'opacity': viewLocation === 'add-association' ? '1' : 
                (item.project_enabled == 1 ? '0.98' : '1')}"
              class="form-check">
              <button
                type="button"
                class="btn btn-sm btn-icon position-absolute select-all-child tooltip bottom font-1x p-0"
                [attr.aria-label]="'Select all child node'"
                data-tooltip="Select all child node hint"
                *ngIf="item.children && item.children.length > 0 && clicked === item && !item.disabled"
                (click)="selectAllChildren(item);"
                id="{{'select-child-'}}-{{item.value}}">
                <em
                  class="material-icons-outlined font-4x"
                  aria-hidden="true">
                  checklist</em>
              </button>
              <input
                id="{{'currentNode'}}-{{item.value}}"
                [disabled]="viewLocation === 'add-association' ? 
                  (item.is_document === 1 ? disableDocument : false) : 
                  (item.project_enabled == 1 ? true : false)"
                type="checkbox"
                [checked]="item.checked"
                class="form-check-input"
                (click)="getCurrentItem(item,$event);" />
              <label 
                for="{{'currentNode'}}-{{item.value}}"
                class="d-inline form-check-label"
                [ngClass]="viewLocation !== 'create-project' ? '':'pr-1'">
                <ng-container *ngIf="item.is_document === 1">
                  <span [ngClass]="viewLocation !== 'create-project' ? 'sr-only':''">{{item.title}}</span>
                </ng-container>

                <ng-container *ngIf="item.is_document !== 1">
                  <span [ngClass]="viewLocation !== 'create-project' ? 'sr-only':''">
                    {{item.human_coding_scheme | slice:0:charLimit}}
                    {{item.full_statement | slice:0:charLimit}}
                  </span>
                </ng-container>
              </label>
              <button
                *ngIf="viewLocation !== 'create-project'" class="btn p-0"
                [ngClass]="item.isHighlighted ? 'mark':'btn-clear'"
                (click)="emitCurrentSelectedNode(item)">
                <ng-container *ngIf="item.is_document === 1">
                  {{item.title}}
                </ng-container>

                <ng-container *ngIf="item.is_document !== 1">
                  {{item.human_coding_scheme | slice:0:charLimit}}
                  {{item.full_statement | slice:0:charLimit}}
                </ng-container>
              </button>
            </span>
          </div>
        </div>
      </div>

      <div id="{{item.id}}" [attr.aria-labelledby]="'headingOne_'+index">
        <ng-container *ngIf="item.children && item.expand">
          <ng-container *ngTemplateOutlet="branch; context: { $implicit : item.children}">
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- trigger outer node -->
<ng-container *ngTemplateOutlet="branch; context:{ $implicit: treeNodes}">
</ng-container>
